export enum BookingCacheTags {
  BOOKING_AVAILABILITY = 'BOOKING_AVAILABILITY',
  MY_TRIPS = 'MY_TRIPS',
  AVAILABLE_STATIONS = 'AVAILABLE_STATIONS',
}

export enum BookingStates {
  BOOKED = 'BOOKED',
  APPROVED = 'APPROVED',
  DELIVERED = 'DELIVERED',
  SUCCESSFUL = 'SUCCESSFUL',
  CANCELED = 'CANCELED',
  ABORTED = 'ABORTED',
  EXPIRED = 'EXPIRED',
  DECLINED = 'DECLINED',
}
